export default "__VITE_ASSET__Dpm8_MGo__"